var _defs, _rect, _rect2, _g, _g2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56",
    "data-name": "Group 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 582.108,
    height: 225.332,
    viewBox: "0 0 582.108 225.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 0.979,
    x2: -0.383,
    y2: 0.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 0.583,
    x2: -1.305,
    y2: 0.583,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: -0.123,
    x2: -0.501,
    y2: -1.893,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 2.597,
    x2: 0.421,
    y2: 1.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 582.108,
    height: 225.332,
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 506.998,
    height: 150.222,
    rx: 12,
    transform: "translate(37.556 37.555)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(37.556 37.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M554.434,202.771a15.791,15.791,0,0,1,15.772,15.773V331.211a15.791,15.791,0,0,1-15.772,15.775H84.991a15.792,15.792,0,0,1-15.773-15.775V218.544a15.791,15.791,0,0,1,15.773-15.773H554.434m0-3H84.991a18.832,18.832,0,0,0-18.777,18.777V331.211a18.832,18.832,0,0,0,18.777,18.777H554.434a18.832,18.832,0,0,0,18.777-18.777V218.544a18.832,18.832,0,0,0-18.777-18.777Z",
    transform: "translate(-66.214 -199.767)",
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(192.641 63.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M205.264,231.755a10.173,10.173,0,0,1-2.8,7.523,10.926,10.926,0,0,1-8.279,3.334,11.77,11.77,0,1,1,0-23.54,11.62,11.62,0,0,1,4.626.944,9.3,9.3,0,0,1,3.525,2.518l-1.981,1.982a7.613,7.613,0,0,0-6.17-2.674,9,9,0,1,0,6.294,15.485,7.085,7.085,0,0,0,1.889-4.564h-8.183v-2.707h10.919A9.63,9.63,0,0,1,205.264,231.755Z",
    transform: "translate(-182.267 -218.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102_-_Outline",
    "data-name": "Path 102 - Outline",
    d: "M194.3,242.939a11.984,11.984,0,1,1,0-23.968,11.878,11.878,0,0,1,4.71.962,9.546,9.546,0,0,1,3.6,2.577l.126.15-2.285,2.286-.15-.179a7.445,7.445,0,0,0-6.006-2.6,8.787,8.787,0,1,0,6.143,15.119,6.79,6.79,0,0,0,1.8-4.2h-8.161v-3.135H205.4l.032.176a9.9,9.9,0,0,1,.161,1.738,10.424,10.424,0,0,1-2.861,7.674A11.172,11.172,0,0,1,194.3,242.939Zm0-23.54a11.556,11.556,0,1,0,0,23.112,10.762,10.762,0,0,0,8.124-3.268,10.015,10.015,0,0,0,2.739-7.375,9.354,9.354,0,0,0-.124-1.486H194.515v2.279h8.2l-.02.232a7.324,7.324,0,0,1-1.95,4.7,9.207,9.207,0,1,1-6.445-15.85,7.883,7.883,0,0,1,6.181,2.574l1.678-1.679a9.232,9.232,0,0,0-3.318-2.31A11.451,11.451,0,0,0,194.3,219.4Z",
    transform: "translate(-182.381 -218.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M215.8,222.218H205.542v7.143H214.8v2.707h-9.254v7.143H215.8v2.769H202.649V219.449H215.8Z",
    transform: "translate(-175.497 -218.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103_-_Outline",
    "data-name": "Path 103 - Outline",
    d: "M202.549,219.349h13.583v3.2H205.87v6.715h9.254V232.4H205.87v6.715h10.262v3.2H202.549Zm13.155.428H202.977v22.1H215.7V239.54H205.442v-7.571H214.7v-2.279h-9.254v-7.571H215.7Z",
    transform: "translate(-175.61 -218.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M223.948,241.981h-2.9V222.218h-6.294v-2.769h15.485v2.769h-6.294Z",
    transform: "translate(-171.432 -218.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104_-_Outline",
    "data-name": "Path 104 - Outline",
    d: "M224.276,242.309h-3.325V222.546h-6.294v-3.2H230.57v3.2h-6.294Zm-2.9-.428h2.469V222.118h6.294v-2.341H215.085v2.341h6.294Z",
    transform: "translate(-171.546 -218.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M234.738,241.981V219.449h2.895v22.532Z",
    transform: "translate(-164.724 -218.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105_-_Outline",
    "data-name": "Path 105 - Outline",
    d: "M237.96,242.309h-3.322v-22.96h3.322Zm-2.894-.428h2.466v-22.1h-2.466Z",
    transform: "translate(-164.838 -218.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M248.83,241.981h-2.9V222.218H239.64v-2.769h15.483v2.769H248.83Z",
    transform: "translate(-163.078 -218.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106_-_Outline",
    "data-name": "Path 106 - Outline",
    d: "M249.158,242.309h-3.325V222.546H239.54v-3.2h15.911v3.2h-6.294Zm-2.9-.428h2.469V222.118h6.294v-2.341H239.968v2.341h6.293Z",
    transform: "translate(-163.192 -218.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M278.165,239.2a11.7,11.7,0,0,1-16.523,0,12.173,12.173,0,0,1,0-16.708,11.66,11.66,0,0,1,16.508.015,12.138,12.138,0,0,1,.015,16.694Zm-14.384-1.886a8.663,8.663,0,0,0,12.242,0,9.6,9.6,0,0,0,0-12.936,8.663,8.663,0,0,0-12.242,0,9.612,9.612,0,0,0,0,12.936Z",
    transform: "translate(-156.806 -218.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107_-_Outline",
    "data-name": "Path 107 - Outline",
    d: "M270.015,242.939a11.291,11.291,0,0,1-8.412-3.48,12.387,12.387,0,0,1,0-17.007,11.874,11.874,0,0,1,16.815.015,12.352,12.352,0,0,1,.015,16.992A11.314,11.314,0,0,1,270.015,242.939Zm0-23.54a10.878,10.878,0,0,0-8.105,3.352,11.959,11.959,0,0,0,0,16.41,11.485,11.485,0,0,0,16.216,0,11.925,11.925,0,0,0-.015-16.4A10.9,10.9,0,0,0,270.015,219.4Zm0,20.772a8.517,8.517,0,0,1-6.272-2.6,9.826,9.826,0,0,1,0-13.237,8.877,8.877,0,0,1,12.547,0,9.818,9.818,0,0,1,0,13.237A8.51,8.51,0,0,1,270.015,240.171Zm0-18a8.1,8.1,0,0,0-5.968,2.469,9.4,9.4,0,0,0,0,12.636,8.449,8.449,0,0,0,11.937,0,9.391,9.391,0,0,0,0-12.636A8.1,8.1,0,0,0,270.015,222.169Z",
    transform: "translate(-156.92 -218.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M278.7,241.981V219.449h3.524l10.951,17.528h.126l-.126-4.342V219.449h2.9v22.532h-3.021L281.6,223.6h-.124l.124,4.342v14.036Z",
    transform: "translate(-149.964 -218.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108_-_Outline",
    "data-name": "Path 108 - Outline",
    d: "M296.405,242.309h-3.354l-11.233-18.017.107,3.761v14.256H278.6v-22.96h3.856l10.728,17.17-.109-3.764V219.349h3.325Zm-3.117-.428h2.688v-22.1h-2.469v12.972l.132,4.556h-.465l-10.951-17.528h-3.191v22.1H281.5V228.059l-.13-4.556h.463Z",
    transform: "translate(-150.078 -218.844)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M283.362,265.365A15.973,15.973,0,1,0,299.4,281.338,15.744,15.744,0,0,0,283.362,265.365Zm0,25.654c-4.841,0-9.015-3.994-9.015-9.681,0-5.748,4.174-9.68,9.015-9.68s9.015,3.932,9.015,9.68C292.377,287.025,288.2,291.019,283.362,291.019Zm-34.977-25.654a15.973,15.973,0,1,0,16.033,15.972A15.744,15.744,0,0,0,248.385,265.365Zm0,25.654c-4.841,0-9.015-3.994-9.015-9.681,0-5.748,4.174-9.68,9.015-9.68s9.015,3.932,9.015,9.68C257.4,287.025,253.226,291.019,248.385,291.019Zm-41.607-20.753v6.776h16.215c-.485,3.812-1.755,6.594-3.691,8.531a16.6,16.6,0,0,1-12.525,4.961,18.032,18.032,0,0,1,0-36.06A17.281,17.281,0,0,1,219,259.315l4.78-4.779a23.638,23.638,0,0,0-17-6.837c-13.674,0-25.17,11.133-25.17,24.807s11.5,24.807,25.17,24.807c7.381,0,12.948-2.42,17.3-6.958,4.477-4.479,5.869-10.77,5.869-15.852a22.018,22.018,0,0,0-.363-4.236Zm170.157,5.264c-1.33-3.57-5.384-10.165-13.674-10.165-8.228,0-15.065,6.474-15.065,15.972a15.632,15.632,0,0,0,15.852,15.974,15.886,15.886,0,0,0,13.31-7.079l-5.444-3.63a9.123,9.123,0,0,1-7.866,4.417,8.124,8.124,0,0,1-7.744-4.841l21.358-8.833Zm-21.78,5.324a8.761,8.761,0,0,1,8.348-9.318c2.784,0,5.144,1.392,5.931,3.389Zm-17.365,15.489h7.019v-46.95h-7.019Zm-11.5-27.409h-.242a11.071,11.071,0,0,0-8.411-3.569c-7.986,0-15.307,7.018-15.307,16.033,0,8.956,7.321,15.914,15.307,15.914a10.894,10.894,0,0,0,8.411-3.63h.242v2.3c0,6.111-3.267,9.378-8.531,9.378a8.84,8.84,0,0,1-8.048-5.687l-6.111,2.542a15.223,15.223,0,0,0,14.158,9.438c8.228,0,15.186-4.841,15.186-16.639V266.332h-6.654Zm-8.048,22.085c-4.839,0-8.893-4.054-8.893-9.621,0-5.626,4.054-9.74,8.893-9.74,4.781,0,8.531,4.114,8.531,9.74C326.778,286.965,323.027,291.019,318.247,291.019Zm91.564-41.626H393.019v46.95h7.007V278.555h9.784c7.769,0,15.4-5.623,15.4-14.582S417.579,249.393,409.81,249.393Zm.182,22.628h-9.966V255.927h9.966a8.049,8.049,0,1,1,0,16.094Zm43.308-6.743c-5.074,0-10.329,2.235-12.5,7.188l6.222,2.6c1.329-2.6,3.805-3.443,6.4-3.443,3.624,0,7.309,2.175,7.369,6.04v.484a15.494,15.494,0,0,0-7.309-1.813c-6.7,0-13.529,3.685-13.529,10.571,0,6.282,5.5,10.329,11.658,10.329,4.711,0,7.308-2.114,8.939-4.591h.242v3.624h6.765v-18C467.554,269.93,461.333,265.279,453.3,265.279Zm-.846,25.731c-2.3,0-5.5-1.147-5.5-3.987,0-3.624,3.986-5.013,7.429-5.013a12.487,12.487,0,0,1,6.4,1.571A8.494,8.494,0,0,1,452.454,291.01Zm39.744-24.7-8.034,20.355h-.242l-8.335-20.355h-7.549l12.5,28.449-7.127,15.825h7.309l19.267-44.275Zm-63.12,30.037h7.007v-46.95h-7.007Z",
    transform: "translate(10.08 -146.121)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(75.008 64.372)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M95.991,221.03a7.525,7.525,0,0,0-1.738,5.276v83.058a7.52,7.52,0,0,0,1.738,5.276l.278.271L142.8,268.384v-1.1L96.269,220.757Z",
    transform: "translate(-94.253 -219.537)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M146.1,276.1,130.6,260.589v-1.1l15.512-15.513.35.2,18.375,10.44c5.248,2.983,5.248,7.862,0,10.846L146.458,275.9Z",
    transform: "translate(-82.052 -211.741)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M158.221,271.866,142.36,256l-46.806,46.8c1.731,1.831,4.587,2.058,7.8.231l54.863-31.173",
    transform: "translate(-93.816 -207.705)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M158.221,252.278l-54.863-31.171c-3.218-1.829-6.073-1.6-7.8.23l46.806,46.806Z",
    transform: "translate(-93.816 -219.843)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 63.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M157.871,267.617l-54.513,30.974c-3.049,1.732-5.776,1.618-7.524.04h0l-.281.28h0l.278.27h0c1.748,1.576,4.475,1.694,7.524-.04l54.863-31.173Z",
    transform: "translate(-93.816 -267.617)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M95.991,291.961a7.528,7.528,0,0,1-1.738-5.276v.548a7.529,7.529,0,0,0,1.738,5.277l.28-.281Z",
    transform: "translate(-94.253 -261.216)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M160.934,260.875l-18.725,10.64.35.35,18.375-10.441c2.623-1.491,3.936-3.455,3.936-5.42h0C164.65,257.78,163.314,259.524,160.934,260.875Z",
    transform: "translate(-78.154 -207.704)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M103.8,221.657l73.238,41.611c2.38,1.352,3.716,3.093,3.936,4.874h0c0-1.965-1.312-3.932-3.936-5.423L103.8,221.108c-5.249-2.983-9.542-.5-9.542,5.507v.548C94.253,221.152,98.546,218.674,103.8,221.657Z",
    transform: "translate(-94.253 -219.843)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.82507f7afd5d6da70a442ad10b0ce24c.svg";
export { ForwardRef as ReactComponent };